/**
 * Create a new HTML element and apply options
 * zero checking
 * @param {String} elementType
 * @param {Object} options
 * @returns HTML element
 */

export default function (elementType, options) {
  const element = document.createElement(elementType)
  for (const option in options) {

    switch (option) {
      case 'innerHTML':
        element.innerHTML = options[option]
        break
      case 'classes':   // gotta be an array
        // if (!Array.isArray(options[option])) {
        //   console.error(options[option], 'is not an array')
        //   return
        // }
        element.classList.add(...options[option])  // spread operator
        break
      case 'styles':   // gotta be an object
        const styles = options[option]
        // if (typeof styles !== 'object' || Array.isArray(styles)) {
        //   console.error(styles, 'is not an object')
        //   return
        // }
        for (const style in styles) {
          element.style[style] = styles[style]
        }
        break
      case 'eventListener':
        const opt = options[option]
        element.addEventListener(opt.evt, opt.func)
        break
      default:
        element.setAttribute(option, options[option])
    }
  }
  return element
}